import React, { useState } from 'react'
import DropZone from '../../../../../components/DropZone'
import NewElement from '../NewElement'
import CreateModal from '../CreateModal'
import ButtonForm from './ButtonForm'
import RbmElementCard from '../RbmElementCard'
import crypto from 'crypto'
import { RBM_ELEMENT_ERRORS, RBM_ELEMENT_ERRORS_MESSAGES } from '../constants'
import { PhotoIcon, DocumentTextIcon, PencilSquareIcon } from '@heroicons/react/24/outline'

async function calculateFileHash(file) {
  const arrayBuffer = await file.arrayBuffer()
  const buffer = Buffer.from(arrayBuffer)
  const hash = crypto.createHash('sha256').update(buffer).digest('hex')
  return hash
}

const RichCardMsgForm = ({
  elementInfo = {},
  setInfo,
  isConversational,
  replyOptions,
  errors,
  flowId,
  emailFields = []
}) => {
  const [isNewButtonOpen, setNewButtonOpen] = useState(false)
  const [buttons, setButtons] = useState(elementInfo.buttons || [])
  const [buttonIndex, setButtonIndex] = useState(null)

  const handleDrop = async (files) => {
    const fileHash = await calculateFileHash(files[0])
    setInfo({
      ...elementInfo,
      image: {
        name: files[0].name,
        preview: URL.createObjectURL(files[0]),
        file: files[0],
        hash: fileHash
      }
    })
  }

  const onRemoveImage = () => {
    //remove image from elementInfo
    const { image, ...rest } = elementInfo
    setInfo(rest)
  }

  const createButton = (buttonInfo) => {
    setButtons([...buttons, buttonInfo])
    setInfo({ ...elementInfo, buttons: [...buttons, buttonInfo] })
  }

  const updateButton = (buttonInfo, index) => {
    const newButtons = [...buttons]
    newButtons[index] = buttonInfo
    setButtons(newButtons)
    setInfo({ ...elementInfo, buttons: newButtons })
  }

  const deleteButton = (index) => {
    const newButtons = [...buttons]
    newButtons.splice(index, 1)
    setButtons(newButtons)
    setInfo({ ...elementInfo, buttons: newButtons })
  }

  const handleButtonSubmit = (buttonInfo) => {
    if (buttonIndex === null) {
      createButton(buttonInfo)
    } else {
      updateButton(buttonInfo, buttonIndex)
      setButtonIndex(null)
    }
    setNewButtonOpen(false)
  }

  const handleButtonClicked = (index) => {
    setButtonIndex(index)
    setNewButtonOpen(true)
  }

  const handleCancelButton = () => {
    setButtonIndex(null)
    setNewButtonOpen(false)
  }

  const onSetOpen = (isOpen) => {
    setNewButtonOpen(isOpen)
    if (!isOpen) setButtonIndex(null)
  }

  return (
    <div className="space-y-5">
      <CreateModal open={isNewButtonOpen} setOpen={onSetOpen} isSmall={true}>
        <ButtonForm
          onClick={handleButtonSubmit}
          buttonInfo={buttons[buttonIndex]}
          setOpen={setNewButtonOpen}
          onCancel={handleCancelButton}
          isConversational={isConversational}
          replyOptions={replyOptions}
          emailFields={emailFields}
        />
      </CreateModal>

      <div>
        <label
          htmlFor="image"
          className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2"
        >
          <PhotoIcon className="h-4 w-4 text-gray-400" />
          Imagen de la tarjeta
        </label>
        <DropZone
          image={elementInfo.image}
          onDrop={handleDrop}
          onRemoveImage={onRemoveImage}
        />
        {errors.includes(RBM_ELEMENT_ERRORS.MISSING_IMAGE) && (
          <p className="text-red-500 text-xs mt-1.5">
            {RBM_ELEMENT_ERRORS_MESSAGES[RBM_ELEMENT_ERRORS.MISSING_IMAGE]}
          </p>
        )}
      </div>

      <div>
        <label
          htmlFor="cardTitle"
          className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2"
        >
          <PencilSquareIcon className="h-4 w-4 text-gray-400" />
          Título de la tarjeta
        </label>
        <input
          type="text"
          name="cardTitle"
          id="cardTitle"
          value={elementInfo.title || ''}
          className="block w-full rounded-lg border-gray-300 px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm transition-colors"
          placeholder="Título..."
          onChange={(e) => {
            setInfo({ ...elementInfo, title: e.target.value })
          }}
        />
      </div>

      <div>
        <label
          htmlFor="cardDescription"
          className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2"
        >
          <DocumentTextIcon className="h-4 w-4 text-gray-400" />
          Descripción de la tarjeta
        </label>
        <textarea
          name="cardDescription"
          id="cardDescription"
          rows={3}
          value={elementInfo.description || ''}
          className="block w-full resize-y rounded-lg border-gray-300 px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm transition-colors"
          placeholder="Descripción..."
          onChange={(e) => setInfo({ ...elementInfo, description: e.target.value })}
        />
      </div>

      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-3">Botones</label>
        <div className="flex gap-3 flex-wrap">
          {buttons.map((button, index) => (
            <RbmElementCard
              key={index}
              name={button.text}
              type={button.type}
              isButton={true}
              onClick={() => handleButtonClicked(index)}
              onDelete={() => deleteButton(index)}
            />
          ))}
          {buttons.length < 3 && (
            <NewElement isNewButton={true} action={() => setNewButtonOpen(true)} />
          )}
        </div>
      </div>
    </div>
  )
}

export default RichCardMsgForm
